import { authenticatedAxiosInstance as axios } from "../axios";

const pay = async (id, payload) => axios.post(`/orders/${id}/pay`, payload)

export const PaymentApi = {
    pay
}